<template>
    <div v-loading="loading" element-loading-text="Please don't leave the page! It is Paying" style="overflow-x: hidden;">
        <div class="center mb30" style="padding-top: 50px;">
            <p class="black fs38 fw500">{{ type === '5' ? $t('renew1').toUpperCase() : $t('p18').toUpperCase() }}</p>
            <span class="backyel dib divide"></span>
        </div>
        <div class="p1">
            <el-steps :active="step" align-center class="mb30">
                <el-step v-for="(item, index) in steps" :key="index" :title="$t('step') + (index + 1)" :description="item.desc"></el-step>
            </el-steps>
            <div v-show="step === 0">
                <!-- <img :src="renewurl" alt="" style="width: 100%;margin-top: 50px;"> -->
                <div class="dflex" style="margin-top: 50px;">
                    <div class="backblack" :class="$style.wra">
                        <div class="white center" :class="$style.fisrt">{{ type === '5' ? $t('p17') : $t('p18') }}</div>
                        <div class="yel center" :class="$style.second">HKD $ {{ price }}</div>
                    </div>
                    <div class="f1 backgray dflex fcenter">
                        <ul :class="$style.list" class="gray">
                            <li>{{ $t('p3') }}</li>
                            <li>{{ $t('p4') }}</li>
                            <li>{{ $t('a1') }}</li>
                            <li>{{ $t('p16') }}</li>
                        </ul>
                    </div>
                </div>
                <p class="backgray center fs16" style="line-height:3;margin-top:30px;">
                    <span class="cp link1" @click="$router.push('/termCondition')">{{$t('tac')}}</span>
                </p>
                <p class="backgray center fs16" style="line-height:3;margin-top:30px;">
                    <span class="cp link1" @click="$router.push('/termPersonal')">{{$t('tac1')}}</span>
                </p>
                <div class="gray left fs16" style="margin-bottom: 10px;margin-top:50px;">
                    <p>
                    <el-checkbox v-model="checked1">{{$t('su3')+$t('tac')}}</el-checkbox>
                    </p>
                    <p>
                        <el-checkbox v-model="checked2">{{$t('su3') + $t('tac1')}}
                        </el-checkbox>
                    </p>
                </div>
            </div>
            <div v-show="step === 1" class="fw500">
				<floatball :text="$t('b1')" @saveCallback="saveCallback"></floatball>
				
				<!-- 一个弹窗提示 -->
				<el-dialog
				  :visible.sync="requiredDialogVisible"
				  :width="requiredDialogWidth"
				  center>
					  <div slot="title" style="background-color: #222a33 !important;border-top-left-radius:15px;border-top-right-radius:15px">
							<p class="white fs32 fw500" style="height: 2.5rem;line-height: 2.5rem;">{{ $t('paymentRequestT') }}</p>
					  </div>
					  <div class="center gray fs18">
						  <div v-show="lang === 'zh'" class="center">
								<p class="fs18 fw500">缺失信息</p>
								<br />
								<div style="color: red;">
									<p :class="$style.reqP">女傭姓名</p>
									<p :class="$style.reqP">女傭香港電話</p>
									<p :class="$style.reqP">僱主姓名</p>
									<p :class="$style.reqP">僱主電話</p>
								</div>
								<el-button  type="warning" size="small"  round @click="requiredDialogVisible = false">關閉</el-button>
						  </div>
						  <div v-show="lang === 'en'" class="center">
								<p class="fs18 fw500">Miss information</p>
								<br />
								<div style="color: red;">
									<p :class="$style.reqP">Helper Name</p>
									<p :class="$style.reqP">Helper's HK Mobile</p>
									<p :class="$style.reqP">Employer's Name</p>
									<p :class="$style.reqP">Employer's Mobile</p>
								</div>
								<el-button type="warning" size="small"  round @click="requiredDialogVisible = false">Close</el-button>
						  </div>
					  </div>
				</el-dialog>
				
                <div class="mb30">
                    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="mb30 fs32">{{ $t('hi') }}</h2>
                    <!-- <uinput :title="$t('r1') + $t('colon')" v-model="model['contract_person_name']"></uinput>
                    <uinput :title="$t('pf5') + $t('colon')" v-model="model['mobile']" :half="true">
                        <i class="el-icon-phone"></i>
                    </uinput> -->
                    <!-- <uinput :title="$t('r2') + $t('colon')" v-model="model['relationship']"></uinput> -->
                    <uinput :title="$t('r3') + $t('colon')" v-model="model['helper_name']" :half="true"></uinput>
                    <uinput :title="$t('helper_mobile') + $t('colon')" v-model="model['helper_mobile']">
                        <i class="el-icon-phone"></i>
                    </uinput>
                    <!-- <uinput :title="$t('r4') + $t('colon')" v-model="model['helper_email']" class="showInLargeib" :half="true">
                        <img src="../assets/email1.svg" width="14">
                    </uinput>
                    <uinput :title="$t('r4') + $t('colon')" v-model="model['helper_email']" class="showInSmallb" :full="true">
                        <img src="../assets/email1.svg" width="14">
                    </uinput>
                    <div class="dib mb30 vat" style="width: 45%;margin-right: 4%;">
                        <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('r27') }}</p>
                        <p>
                            <el-date-picker style="width:100%;"
                                v-model="date1"
                                type="date"
                                value-format="MM/dd/yyyy"
                                placeholder="pick date">
                                </el-date-picker>
                        </p>
                    </div> -->
                    <!-- <div class="dib mb30 vat" style="width: 50%;">
                        <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('r28') }}</p>
                        <p>
                            <el-date-picker style="width:100%;"
                                v-model="date2"
                                type="date"
                                value-format="MM/dd/yyyy"
                                placeholder="pick date">
                                </el-date-picker>
                        </p>
                    </div> -->
                    <!-- <div class="dib mb30 vat mr4" :class="$style.hi1">
                        <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('r5') }}</p>
                        <p style="font-size: 23px; margin-right: -20px;">
                            <el-radio v-for="item in marriageArr" :key="item.key" v-model="model['marriage']" :label="item.key">{{item.label}}</el-radio>
                        </p>
                    </div> -->
                    <div class="dib mb30 vat" style="width: 50%;"></div>
                    <!-- <div class="dib mb30 vat mr4" :class="$style.hi1">
                        <p class="fs18 fw500" style="margin-bottom: 10px;">ATTENTION HELPERS:</p>
                        <p class="fs16">Please send required documents to:</p>
                        <p class="fs16">Whatsapp Jeany Rose</p>
                        <p class="fs16">(+63) 950 210 0238</p>
                    </div> -->
                </div>
                <div class="mb30">
                    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="mb30 fs32">{{ $t('r6') }}</h2>
                    <uinput :title="$t('employer_name') + $t('colon')" v-model="model['employer_name']"></uinput>
                    <uinput :title="$t('employer_mobile') + $t('colon')" v-model="model['employer_mobile']" :half="true">
                        <i class="el-icon-phone"></i>
                    </uinput>
                    <!-- <div class="dib mb30 vat mr4" style="width: 45%;">
                        <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('pf16') }}</p>
                        <p style="font-size: 23px; margin-right: -20px;">
                            <el-radio v-model="model['house_type']" label="flat">{{$t('flat')}}</el-radio>
                            <el-radio v-model="model['house_type']" label="house">{{$t('house')}}</el-radio>
                        </p>
                    </div>
                    <uinput :title="$t('pf171') + $t('colon')" v-model="model['house_size']" :half="true">
                        <i class="el-icon-s-home"></i>
                    </uinput> -->
                    <!-- <uselect :title="$t('pf9') + $t('colon')" v-model="model['adult_no']" :options="options"> -->
                        <!-- <i class="el-icon-user-solid" style="vertical-align:-3px;"></i> -->
                    <!-- <img src="../assets/solidUser.png" alt="" style="width: 18px;position: relative;top: 8px;"> -->
                    <!-- </uselect> -->
                    <!-- <uinput :title="$t('r7') + $t('colon')" v-model="model['youngster_no']">
                        <img src="../assets/children.png" alt="" style="width: 22px;position: relative;top: 1px;">
                    </uinput> -->
                    <!-- <uselect :title="$t('r7') + $t('colon')" v-model="model['youngster_no']" :options="options" :half="true">
                        <img src="../assets/children.png" alt="" style="width: 22px;position: relative;top: 7px;">
                    </uselect>
                    <uselect :title="$t('r8') + $t('colon')" v-model="model['children_no']" :options="options">
                        <img src="../assets/children1.png" alt="" style="width: 22px;position: relative;top: 5px;">
                    </uselect>
                    <uselect :title="$t('r9') + $t('colon')" v-model="model['expected_baby_no']" :options="options" :half="true">
                        <img src="../assets/children1.png" alt="" style="width: 22px;position: relative;top: 5px;">
                    </uselect>
                    <uselect :title="$t('pf18') + $t('colon')" v-model="model['bedroom_no']" :options="options">
                        <img src="../assets/bed.png" alt="" style="width: 22px;position: relative;top: 1px;">
                    </uselect> -->
                </div>
                <!-- <div class="showInLargeb">
                    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="mb30 fs32">{{ $t('r10') }}</h2>
                    <div class="dib mb30 vat mr4" :class="$style.hi1">
                        <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('r11') }}</p>
                        <div style="font-size: 23px; margin-right: -20px;">
                            <el-radio v-model="helperRoom" label="yes">
                                <span>{{$t('r12')}}</span>
                                <uinput v-model="hr11" style="width: 60px;margin: 0px;vertical-align: 4px;margin: 0 10px;" :isSmall="true"></uinput>
                                <span>{{$t('r13')}}</span>
                                <el-radio v-model="hr12" label="meter">{{$t('r14')}}</el-radio>/
                                <el-radio v-model="hr12" label="ft">{{$t('r15')}}</el-radio>
                            </el-radio>
                            <el-radio v-model="helperRoom" label="no">
                                <span>{{$t('r16')}}</span>
                            </el-radio>
                            <div style="margin-left: 50px;">
                                <el-radio v-model="h2" label="1">
                                    <span>{{$t('r17')}}</span>
                                    <uinput v-model="h211" style="width: 60px;margin: 0px;vertical-align: 4px;margin: 0 10px;" :isSmall="true"></uinput>
                                    
									
									<span>{{$t('r13')}}</span>
                                    
									
									<el-radio v-model="h212" :label="$t('r18')"></el-radio>
                                    <el-radio v-model="h212" :label="$t('pf32')"></el-radio>
                                    <uinput v-model="h213" style="width: 60px;margin: 0px;vertical-align: 4px;margin: 0 10px;" :isSmall="true"></uinput>
                                    <span>{{$t('age')}}</span>
                                    <uinput v-model="h214" style="width: 60px;margin: 0px;vertical-align: 4px;margin: 0 10px;" :isSmall="true"></uinput>
                                    <span>{{$t('r19')}}</span>
                                </el-radio>
                                <el-radio v-model="h2" label="2">
                                    <span>{{$t('r191')}}</span>
                                    <uinput v-model="h221" style="width: 60px;margin: 0px;vertical-align: 4px;margin: 0 10px;" :isSmall="true"></uinput>
                                    <span>{{$t('r13')}}</span>
                                    <el-radio v-model="h222" label="meter">{{$t('r14')}}</el-radio>/
                                    <el-radio v-model="h222" label="ft">{{$t('r15')}}</el-radio>
                                </el-radio>
                                <el-radio v-model="h2" label="3">
                                    <span>{{$t('r20')}}</span>
                                    <uinput v-model="h231" style="width: 300px;margin: 0px;vertical-align: 4px;margin: 0 10px;" :isSmall="true"></uinput>
                                </el-radio>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="showInSmallb">
                    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="mb30 fs32">{{ $t('r10') }}</h2>
                    <div class="dib mb30 vat" :class="$style.hi1">
                        <p class="fs28 fw500" style="margin-bottom: 10px;">{{ $t('r11') }}</p>
                        <div class="fs14">
                            <el-radio v-model="helperRoom" label="yes">
                                <span>{{$t('r12')}}</span>
                                <uinput v-model="hr11" style="width: 20px;vertical-align: -4px;margin: 0px;" :isSmall="true"></uinput>
                                <!-- <span>{{$t('r13')}}</span> -->
                                <!-- <div class="dib" style="vertical-align: -10px;">
                                    <p>
                                        <el-radio v-model="hr12" label="meter">{{$t('r14')}}</el-radio>
                                    </p>
                                    <p>
                                        <el-radio v-model="hr12" label="ft">{{$t('r15')}}</el-radio>
                                    </p>
                                </div> -->
                            <!-- </el-radio> -->
                            <!-- <el-radio v-model="helperRoom" label="no">
                                <span>{{$t('r16')}}</span>
                            </el-radio>
                            <div style="margin-left: 10px;">
                                <el-radio v-model="h2" label="1">
                                    <span>{{$t('r17')}}</span>
                                    <uinput v-model="h211" style="width: 20px;margin: 0px;vertical-align: -4px;" :isSmall="true"></uinput>
                                    <div class="dib" style="margin-left: 10px;vertical-align: -14px;">
                                        <p>
                                            <el-radio v-model="h212" style="margin-right:10px;" :label="$t('r18')"></el-radio>
                                            <span>{{$t('age')}}</span>
                                            <uinput v-model="h214" style="width: 30px;margin: 0px;vertical-align: -4px;" :isSmall="true"></uinput>
                                        </p>
                                        <p>
                                            <el-radio v-model="h212" style="margin-right:10px;" :label="$t('pf32')"></el-radio>
                                            <uinput v-model="h213" style="width: 30px;margin: 0px;vertical-align: -4px;" :isSmall="true"></uinput>
                                        </p>
                                    </div>
                                    <span>{{$t('r19')}}</span>
                                </el-radio>
                                <el-radio v-model="h2" label="2">
                                    <span>{{$t('r191')}}</span>
                                    <uinput v-model="h221" style="width: 30px;margin: 0px;vertical-align: -4px;" :isSmall="true"></uinput> -->
                                    <!-- <span>{{$t('r13')}}</span> -->
                                    <!-- <div class="dib" style="vertical-align: -10px;">
                                        <p>
                                            <el-radio v-model="h222" label="meter">{{$t('r14')}}</el-radio>
                                        </p>
                                        <p>
                                            <el-radio v-model="h222" label="ft">{{$t('r15')}}</el-radio>
                                        </p>
                                    </div> -->
                                <!-- </el-radio>
                                <el-radio v-model="h2" label="3">
                                    <span>{{$t('r20')}}</span>
                                    <uinput v-model="h231" style="width: 150px;margin: 0px;vertical-align: -4px;" :isSmall="true"></uinput>
                                </el-radio>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div>
                    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="mb30 fs28">{{ $t('r21') }}</h2>
                    <div class="mb30 fs18 showInLargeb">
                        <div class="dflex center mb30">
                            <p style="width:24%;">{{$t('r22')}}</p>
                            <p style="width:24%;">{{$t('r23')}}</p>
                            <p style="width:24%;">{{$t('r24')}}</p>
                            <p style="width:24%;">{{$t('r25')}}</p>
                        </div>
                        <div v-for="(item, index) in familyMembers" :key="index">
                            <uinput style="width:24%;margin: 0px;" v-model="item['last_name']"></uinput>
                            <uinput style="width:24%;margin: 0px;" v-model="item['family_relationship']"></uinput>
                            <uinput style="width:24%;margin: 0px;" v-model="item['year_of_birth']"></uinput>
                            <uinput style="width:24%;margin: 0px;" v-model="item['id_number']"></uinput>
                        </div>
                    </div>
                    <div class="showInSmallb">
                        <div v-for="(item, index) in familyMemberss" :key="index">
                            <uinput :title="$t('r22') + $t('colon')" v-model="item['last_name']"></uinput>
                            <uinput :title="$t('r23') + $t('colon')" v-model="item['family_relationship']" :half="true"></uinput>
                            <uinput :title="$t('r24') + $t('colon')" v-model="item['year_of_birth']"></uinput>
                            <uinput :title="$t('r25') + $t('colon')"  :half="true" v-model="item['id_number']"></uinput>
                        </div>
                    </div>
                    <div class="center">
                        <p @click="addFM" :disabled="!canAddfm" :class="$style.add">
                            <img src="../assets/add.png" alt="" width="30" style="vertical-align:-9px;">
                            {{$t('renew3')}}
                        </p>
                    </div>
                </div> -->
                <!-- <div>
                    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="mb30 fs28">{{ $t('r29')+'1: '+ $t('r30') }}</h2>
                    <div class="mb30 fs18 showInLargeb">
                        <div class="dflex center mb30">
                            <p style="width:33%;">{{$t('r31')}}</p>
                            <p style="width:33%;">{{$t('r32')}}</p>
                            <p style="width:33%;">{{$t('r33')}}</p>
                        </div>
                        <div v-for="(item, index) in replaceHelpers" :key="index">
                            <uinput style="width:33%;margin: 0px;" v-model="item['Helper Full Name']"></uinput>
                            <uinput style="width:33%;margin: 0px;" v-model="item['HKID No']"></uinput>
                            <div class="dib mb30 vat" style="width:33%;margin: 0px;">
                                <el-date-picker style="width:100%;" class="customdate"
                                    v-model="item['Release Date From Existing Employer']"
                                    type="date"
                                    value-format="MM/dd/yyyy"
                                    placeholder="pick date">
                                    </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="showInSmallb">
                        <div v-for="(item, index) in replaceHelpers" :key="index">
                            <uinput :title="$t('r31') + $t('colon')" v-model="item[`Helper Full Name`]"></uinput>
                            <uinput :title="$t('r32') + $t('colon')" v-model="item['HKID No']" :half="true"></uinput>
                            <div class="dib mb30 vat" style="width: 45%;margin-right: 4%;">
                                <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('r35') + $t('colon') }}</p>
                                <p>
                                    <el-date-picker style="width:100%;"
                                        v-model="item['Release Date From Existing Employer']"
                                        type="date"
                                        format="MM/dd/yyyy"
                                        placeholder="pick date">
                                        </el-date-picker>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="center">
                        <p @click="addHR" :class="$style.add">
                            <img src="../assets/add.png" alt="" width="30" style="vertical-align:-9px;">
                            {{$t('renew31')}}
                        </p>
                    </div>
                </div> -->
                <!-- <div>
                    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="mb30 fs28">{{ $t('r29')+'2: '+ $t('r34') }}</h2>
                    <div class="mb30 fs18 showInLargeb">
                        <div class="dflex center mb30">
                            <p style="width:16%;">{{$t('r31')}}</p>
                            <p style="width:16%;">{{$t('r32')}}</p>
                            <p style="width:16%;">{{$t('r35')}}</p>
                            <p style="width:16%;">{{$t('r36')}}</p>
                            <p style="width:16%;">{{$t('r37')}}</p>
                            <p style="width:16%;">{{$t('r38')}}</p>
                        </div>
                        <div v-for="(item, index) in otherHelpers" :key="index">
                            <uinput style="width:16%;margin: 0px;" v-model="item['Helper Full Name']"></uinput>
                            <uinput style="width:16%;margin: 0px;" v-model="item['HKID No']"></uinput>
                            <div class="dib mb30 vat" style="width:16%;margin: 0px;">
                                <el-date-picker style="width:100%;" class="customdate"
                                    v-model="item['Permitted to Remain Until (see white visa slip)']"
                                    type="date"
                                    value-format="MM/dd/yyyy"
                                    placeholder="pick date">
                                    </el-date-picker>
                            </div>
                            <div class="dib mb30 vat" style="width:16%;margin: 0px;">
                                <el-date-picker style="width:100%;" class="customdate"
                                    v-model="item['Release Date From Existing Employer']"
                                    type="date"
                                    value-format="MM/dd/yyyy"
                                    placeholder="pick date">
                                    </el-date-picker>
                            </div>
                            <uinput style="width:16%;margin: 0px;" v-model="item['Name of Employer']"></uinput>
                            <uinput style="width:16%;margin: 0px;" v-model="item['Room Arrangement']"></uinput>
                        </div>
                    </div>
                    <div class="showInSmallb">
                        <div v-for="(item, index) in otherHelpers" :key="index">
                            <uinput :title="$t('r31') + $t('colon')" v-model="item[`Helper Full Name`]"></uinput>
                            <uinput :title="$t('r32') + $t('colon')" v-model="item['HKID No']" :half="true"></uinput>
                            <div class="dib mb30 vat" style="width: 45%;margin-right: 4%;">
                                <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('r35') + $t('colon') }}</p>
                                <p>
                                    <el-date-picker style="width:100%;"
                                        v-model="item['Permitted to Remain Until (see white visa slip)']"
                                        type="date"
                                        format="MM/dd/yyyy"
                                        placeholder="pick date">
                                        </el-date-picker>
                                </p>
                            </div>
                            <div class="dib mb30 vat" style="width: 50%;">
                                <p class="fs18 fw500" style="margin-bottom: 10px;">{{ $t('r36') + $t('colon') }}</p>
                                <p>
                                    <el-date-picker style="width:100%;"
                                        v-model="item['Release Date From Existing Employer']"
                                        type="date"
                                        format="MM/dd/yyyy"
                                        placeholder="pick date">
                                        </el-date-picker>
                                </p>
                            </div>
                            <uinput :title="$t('r37') + $t('colon')" v-model="item['Name of Employer']"></uinput>
                            <uinput :title="$t('r38') + $t('colon')" v-model="item['Room Arrangement']" :half="true"></uinput>
                        </div>
                    </div>
                    <div class="center">
                        <p @click="addOH" :class="$style.add">
                            <img src="../assets/add.png" alt="" width="30" style="vertical-align:-9px;">
                            {{$t('renew31')}}
                        </p>
                    </div>
                </div> -->
				
				<!-- 新增菲佣类型 -->
				<!-- <div class="showInLargeb">
				    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="fs28">{{ $t('paymentN1') }}</h2>
					<p class="fs18 fw500" style="margin-bottom: 10px;margin-top: 20px;">{{$t('paymentN2')}}</p>
				    <div style="margin-top: 40px;">
				        <p :class="$style.st1">
				            <span class="gray">{{ $t('paymentN3') }}</span><span class="gray" style="margin-right: 20px;">:</span>
				            <span :class="$style.value">{{ model['helper_name'] }}</span>
				        </p>
						<p :class="$style.st1">
						    <span class="gray">{{ $t('paymentN4') }}</span><span class="gray" style="margin-right: 20px;">:</span>
						    <span :class="$style.value">{{ paidate }}</span>
						</p>
						<p :class="$style.st1">
						    <span class="gray">{{ $t('paymentN5') }}</span><span class="gray" style="margin-right: 20px;">:</span>
						    <span :class="$style.value">{{ csdate }}</span>
						</p>
				    </div>
					<uselect :title="$t('pSelectT')" v-model="model['helperSType']" :options="hOptions">
					    
					</uselect>
				</div>
				<div class="showInSmallb">
				    <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="fs28">{{ $t('paymentN1') }}</h2>
					<p class="fs18 fw500" style="margin-bottom: 10px;">{{$t('paymentN2')}}</p>
				    <div style="margin-top: 40px;">
				        <p :class="$style.st1">
				            <span class="gray">{{ $t('paymentN3') }}</span><span class="gray" style="margin-right: 20px;">:</span>
				            <span :class="$style.value">{{ model['helper_name'] }}</span>
				        </p>
				    	<p :class="$style.st1">
				    	    <span class="gray">{{ $t('paymentN4') }}</span><span class="gray" style="margin-right: 20px;">:</span>
				    	    <span :class="$style.value">{{ paidate }}</span>
				    	</p>
				    	<p :class="$style.st1">
				    	    <span class="gray">{{ $t('paymentN5') }}</span><span class="gray" style="margin-right: 20px;">:</span>
				    	    <span :class="$style.value">{{ csdate }}</span>
				    	</p>
				    </div>
				    <uselect :title="$t('pSelectT')" v-model="model['helperSType']" :options="hOptions">
				        
				    </uselect>
				</div> -->
				
            </div>
            <!-- 附加服務 -->
            <div v-show="step === 2" class="fw500 bigRadio">
                <h2 style="border-bottom: 1px solid #222a33;line-height: 3;" class="fs28">{{ $t('aservice') }}</h2>
                <div style="border-bottom: 1px solid #222a33;color:#508098;line-height:2;" class="fs24" :class="$style.pt100">
                    <p>{{ $t('renew5') }}</p>
                    <p >{{ $t('renew6') }}</p>
                </div>
                <!-- <div style="margin-top:40px;"><el-radio v-model="model['additional_service']" label="None">{{ $t('none') }}</el-radio></div>
                <div style="margin-top:20px;"><el-radio v-model="model['additional_service']" label="2 Year MaidSafe Insurance">{{ $t('a2y') }}</el-radio></div>
                <p class="yel" :class="$style.incost">+ {{ $t('money') }} ${{ insurancePrice }}</p>
                <p style="margin: 50px 40px;" class="fs24">
                    <a class="link" :href="$service.insurance" target="_blank">{{ $t('insdetail') }}</a>
                </p>
                <div style="border-bottom: 1px solid #222a33;padding: 40px;" class="fs24">
                    {{ $t('renewcost') }}
                    <span style="padding-left: 20px;" class="yel">{{ $t('money') }} 1680</span>
                </div>
                <div style="margin: 40px;">
                    <p class="fs24">{{ $t('total') }}</p>
                    <p class="fs26 yel">{{ $t('money') }} {{ totalPrice }}</p>
                </div> -->
            </div>
            <div v-show="step === 3" class="center">
				<p class="fs18" style="margin-top: 40px;">{{$t('payamount')}}</p>
				<p class="fs24 mb30">${{totalPrice}}</p>
				<p >{{$t('pSelectPay')}}:</p>
                <div :class="$style.verticalrg" style="margin-top: 50px;width: 13.375rem;margin: 0 auto;">
                	<el-radio-group v-model="model['payType']">
                		<el-radio  label="1" style="margin-bottom: 2.5rem;">
                			<img src="../assets/paypay.png" alt="" style="width: 6.25rem;">
                			<span class="f1">{{ $t("paypalT1") }}</span>
                		</el-radio>
                		<br />
                		<el-radio  label="2" style="margin-bottom: 2.5rem;">
                			<img src="../assets/payment_ATM.png" alt="" style="width: 6.25rem;">
							<span class="f1">{{ $t("paypalT2") }}</span>
                		</el-radio>
                		<br />
                		<el-radio  label="3" style="margin-bottom: 2.5rem;">
                			<img src="../assets/payment_FPS.png" alt="" style="width: 6.25rem;">
							<span class="f1">{{ $t("paypalT3") }}</span>
                		</el-radio>
						<br />
                	</el-radio-group>
                	<!-- :class="$style.vertical" -->
                </div>
				<div v-if="model['payType'] == 1">
					<div style="margin-top: 30px;">
						<p v-if="err" class="red center" style="margin-bottom: 20px;">{{err}}</p>
						<a id='payLinks' href="http://www.baidu.com" style='display:none;'></a>
						<el-button type="info" size="large" style="width:180px;" @click="onPayClick">
						    <i class="el-icon-lock"></i>
						    {{$t('pay1')}}</el-button>
						<div v-if="success" class="yellow center" style="margin-top: 20px;">
						    <p>{{ $t('paySuccess1') }}</p>
						    <p>{{ $t('paySuccess2') }}</p>
						    <p>{{ $t('paySuccess3') }}</p>
						</div>
					</div>
				</div>
				<div v-else-if="model['payType'] == 2">
					<amt></amt>
				</div>
				<div v-else>
					<fps></fps>
				</div>
                <div v-show="model['payType'] != 1" :class="$style.credentialDiv">
                	<p style="margin-top: 20px;padding: 0 0.625rem;">{{ $t('amtf1') }}</p>
                	<p style="padding: 0 0.625rem;">{{ $t('amtf2') }}</p>
                	<div style="margin:20px 0;">
						<span style="margin-right: 1.25rem;">
							<a @click="editAvatar" :class="$style.editbtn">{{$t('pfile')}}</a>
							<input style="display:none;" type="file" accept="image/*" ref="avatar" @change="onFileEdit">
						</span>
						<i v-show="model['credential'] != ''" class="el-icon-delete" style="cursor: pointer;" @click="delFile"></i>
                	</div>
                	<div>
                		<img class="mcenter" :src="model['credential']" alt="" style="max-width: 600px;">
                	</div>
                	<div style="margin-top: 20px;">
						<p v-if="err" class="red center" style="margin-bottom: 20px;">{{err}}</p>
                		<el-button type="warning" size="large" style="width:180px;" @click="onSureClick" :disabled="!canSubmit">
                			{{$t('confirmOrder')}}
                		</el-button>
                	</div>
                </div>
                
                <template>
                    <p style="margin-top:40px;">{{ $t('afterpay1') }}</p>
                    <p>{{ $t('afterpay2') }}</p>
                </template>
            </div>
            <div v-show="step === 4" class="gray">
                <!-- <img :src="sendfileurl" alt="" style="width: 100%; margin-top:30px;margin-bottom:40px;"> -->
                <h1 class="fs24 center sendInfo" style="margin-top:50px;">{{$t('tr1')}}</h1>
                <h1 class="fs24 center sendInfo">{{$t('tr2')}}</h1>
                <div class="dflexx acsb" style="padding: 50px 100px;">
                    <div class="center mb30">
                        <img src="../assets/email.png" alt="" width="80">
                        <p class="black mt10">doc@goldenwin.com.hk</p>
                    </div>
                    <div class="center cp" @click="goWhatsappPay">
                        <img src="../assets/whatsapp.png" alt="" width="80">
                        <p class="black mt10">{{ $t('w1') }}</p>
                    </div>
                </div>
                <uinfo v-if="type === '6'"></uinfo>
                <div v-else class="dflex fw" :class="$style.s4">
                    <div :class="$style.step4" class="dflex mb40">
                        <p class="yel fs50" style="width:37px;">1</p>
                        <img src="../assets/hkid.png" alt="" width="70" height="60" class="mr35">
                        <p class="fs18 fw500 pt15">{{$t('tr3')}}</p>
                    </div>
                    <div :class="$style.step4" class="dflex mb40">
                        <p class="yel fs50" :class="$style.s41">2</p>
                        <img src="../assets/doc.png" alt="" width="70" height="60" class="mr35">
                        <div>
                            <p class="fs18 fw500 pt15">{{$t('tr4')}}</p>
                            <p class="fs16 fw500 pt15" v-if="$i18n.locale=== 'en'">{{$t('tr5')}}</p>
                            <p class="fs16 fw500 pt15">{{$t('tr6')}}</p>
                        </div>
                    </div>
                    <div :class="$style.step4" class="dflex mb40">
                        <p class="yel fs50" style="width:37px;">3</p>
                        <img src="../assets/hkid.png" alt="" width="70" height="60" class="mr35">
                        <p class="fs18 fw500 pt15">{{$t('tr7')}}</p>
                    </div>
                    <div :class="$style.step4" class="dflex mb40">
                        <p class="yel fs50" :class="$style.s41">4</p>
                        <img src="../assets/hkid.png" alt="" width="70" height="60" class="mr35">
                        <p class="fs18 fw500 pt15">{{$t('tr8')}}</p>
                    </div>
                </div>
            </div>
            <div class="dflex acsb" style="margin-top: 40px;">
                <ubutton :text="$t('pre')" :disabled="!canPre" @click="step--"></ubutton>
                <ubutton v-if="!isLast" :text="$t('next')" :disabled="!canNext" @click="nextClick"></ubutton>
                <ubutton v-else @click="$router.push('/index')" :text="$t('renew4')"></ubutton>
            </div>
        </div>
    </div>
</template>
<script>
import { format } from 'date-fns';
import {companies} from '../data.js';
import renewen from '../assets/renewen.png';
import renewzh from '../assets/renewzh.png';
import sendfileen from '../assets/sendfileen.png';
import sendfilezh from '../assets/sendfilezh.png';
import {priceMap} from '../data.js';
import floatball from '../components/FloatBall.vue';
import amt from '../components/amt.vue';
import fps from '../components/fps.vue';

const fm =() => ({
    last_name: '',
    family_relationship: '',
    year_of_birth: '',
    id_number: '',
});
const hr =() => ({
    "Helper Full Name": '',
    "HKID No": '',
    "Release Date From Existing Employer": '',
});
const oh =() => ({
    "Helper Full Name": '',
    "HKID No": '',
    "Permitted to Remain Until (see white visa slip)": '',
    "Release Date From Existing Employer": '',
    "Name of Employer": '',
    "Room Arrangement": '',
});
export default {
    name: 'Renew',
    props: {
        type: String,
        orderId: String,
    },
	components:{
		floatball,
		amt,
		fps
	},
    data() {
        const companiesName = companies.map((item) => ({
            value: item.name,
            label: item.name})
        ) || [];
        const lang = this.$i18n.locale;
        const familyMembers = [];
        const familyMemberss = [fm()];
        for (let i = 0; i < 3; ++i) {
            familyMembers.push(fm());
        }
        const options = [];
        for(let i = 0; i <= 7; ++i) {
            options.push({
                value: i,
                text: i,
                lable: i,
            });
        }
		// const hOptions = [];
		// for(let n = 1; n <= 6; ++n) {
		//     hOptions.push({
		//         value: this.$t('pSelectN'+n),
		//         text: this.$t('pSelectN'+n),
		//         lable: this.$t('pSelectN'+n),
		//     });
		// }
		const tDate = new Date();
		const cDate = new Date();
		cDate.setDate(cDate.getDate() + 6);
        return {
            step: 0,
            steps: [
                {desc: this.$t('tac')},
                {desc: this.$t('step1')},
                {desc: this.$t('aservice')},
                {desc: this.$t('step2')},
                {desc: this.$t('step3')},
            ],
            options,
			// hOptions,
            price: priceMap[this.type] || 0,
            insurancePrice: 1280,
            lang,
            renewurl: lang === 'en' ? renewen : renewzh,
            checked1: false,
            checked2: false,
            sendfileurl: lang === 'en' ? sendfileen : sendfilezh,
            startWork: '1',
            startWorkDate: new Date(),
            companiesName,
            company: companiesName.length > 0 ? companiesName[0].value : '',
            marriageArr: [{key: 'live in partner', label: this.$t('m0') }, {key: 'single', label: this.$t('m1')}, {key: 'married', label: this.$t('m2')}, {key: 'seperated', label: this.$t('m3')}, {key: 'widow', label: this.$t('m4')}],
            date1: '',
            date2: '',
			requiredDialogWidth: '50%',
			requiredDialogVisible: false,
            model: {
               employer_name: '',
               employer_mobile: '',
               contract_person_name: '',
               mobile: '',
               relationship: '',
               helper_name: '',
               helper_mobile: '',
               helper_email: '',
               marriage: '',
               house_type: '',
               house_size: '',
               adult_no: '',
               youngster_no: '',
               children_no: '',
               expected_baby_no: '',
               bedroom_no: '',
               helper_accommodation: '',
               family_member: '', // json
               additional_service: 'None',
               total_money: '',
               type: this.type === '5' ? 1 : 2,
               last_visa_date: '',
               last_working_date: '',
               remark_1: '', //json
               remark_2: '', //json
			   helperSType: '',
			   payType: 1,
			   credential: "",
            },
            helperRoom: '',
            hr11: '',
            hr12: '',
            h2: '',
            h211: '',
            h212: '',
            h213: '',
            h214: '',
            h221: '',
            h222: '',
            h231: '',
            familyMembers,
            familyMemberss,
            replaceHelpers: [hr()],
            otherHelpers: [oh()],
            err: '',
            loading: false,
            success: false,
            renewNo: '',
            orderNo: '',
            cancel: false,
			paidate: tDate.toLocaleString('en-US', { month: 'short' }) + " " + tDate.getDate() + " " + tDate.getFullYear(),
			csdate: cDate.toLocaleString('en-US', { month: 'short' }) + " " + cDate.getDate() + " " + cDate.getFullYear(),
			canSubmit: true,
        }
    },
    computed: {
        formatStartWorkDate() {
            return format(this.startWorkDate, 'MM/dd/yyyy');
        },
        canPre() {
            return this.step !== 0 && !(this.step === 3 && this.orderNo);
        },
        canNext() {
            let res = true;
            if (this.step === 0) {
                if (!this.checked1 || !this.checked2)
                    res = false;
            }
            return res && this.step !== (this.steps.length - 1);
        },
        isLast() {
            return this.step === (this.steps.length - 1);
        },
        totalPrice() {
            return this.price + (this.model['additional_service'] === 'None' ? 0 : this.insurancePrice);
        },
        canAddfm() {
            return this.familyMembers.length < 10 && this.familyMemberss.length < 10;
        }
    },
    watch: {
        step() {
            this.$top();
        },
        success(value) {
            if (value) {
                // this.$notify({
                //     title: this.$t('success'),
                //     message: this.$t('paySuccess'),
                //     type: 'success'
                // });
                this.$alert(this.$t('paySuccess'), this.$t('success'), {
                    type: 'success'
                });
            }
        },
		model:{
			handler(val, oldVal){
				this.postCacheTable();
			},
			deep:true
		}
    },
    created() {
        this.$top();
        this.orderNo = this.$route.query['order_no'];
        this.cancel = this.$route.query['cancel'];
        this.initOrder();
		this.getCacheTable();
    },
    methods: {
		nextClick(){
			if (this.step === 1) {
				if (
					this.model.helper_name == '' ||
					this.model.helper_mobile == '' || 
					this.model.employer_name == '' ||
					this.model.employer_mobile == '' 
				) {
					this.requiredDialogVisible = true;
					return;
				}
			}
			
			if (this.canSubmit === true && this.step == 3 && this.model.payType != 1) {
				let message =
					this.$i18n.locale === "en" ? 
						"Would you like to book your helper and save your information?If yes,Please click 'Submit'" :
						"請按（提交）以確認為自己選取的女傭";
				this.$message({
					  message: message,
					  type: 'warning',
					  offset: 350,
				});
				return
			}
			this.step++
		},
		editAvatar() {
		    this.$refs.avatar.click();
		},
		onFileEdit(files){
			const fileList = this.$refs.avatar.files;
			let reader = new FileReader();     //html5读文件
			reader.readAsDataURL(fileList[0]); //转BASE64
			reader.onload=(e) => {        //读取完毕后调用接口
			    let file = e.target.result;
				this.model['credential'] = file;
			};
		},
		delFile(){
			this.$refs.avatar.value = "";
			this.model['credential'] = "";
		},
		saveCallback(){
			const familyMembers = JSON.stringify([].concat(this.familyMembers))
			const familyMemberss = JSON.stringify([].concat(this.familyMemberss))
			const replaceHelpers = JSON.stringify([].concat(this.replaceHelpers))
			const otherHelpers = JSON.stringify([].concat(this.otherHelpers))
			var data = this.model;
			data.familyMembers = familyMembers;
			data.familyMemberss = familyMemberss;
			data.replaceHelpers = replaceHelpers;
			data.otherHelpers = otherHelpers;
			const keysArr = [
				'helperRoom','hr11','hr12','h2','h211','h212','h213','h214','h221','h222','h231'
			];
			var that = this;
			keysArr.forEach(function(v){
				data[v] = that.$data[v];
			});
			data.last_visa_date = this.date1;
			data.last_working_date = this.date2
			const params = {
				type:this.type,
				category:'renew',
				table:JSON.stringify(data)
			}
			this.$service.postCacheTable(params);
		},
        initOrder() {
            if (this.orderNo) {
                this.step = 3;
                if (!this.cancel) {
                    this.err = '';
                    this.loading = true;
                    this.success = false;
                    this.checkOrder(this.orderNo);
                } else { // 取消支付
                    this.$notify({
                        title: this.$t('cancel'),
                        message: this.$t('cancelpay'),
                        type: 'warning'
                    });
                    this.$service.checkPay({order_number: this.orderNo}).then((res) => {
                        this.price = res.data.total_money;
                    })
                    this.err = this.$t('cancelpay');
                }
            } else if (this.orderId) {
                this.step = 3;
            }
        },
		onSureClick(){
			this.err = '';
			this.loading = true;
			this.canSubmit = true;
			if (this.model['payType'] != 1 && this.model['credential'] == "") {
				this.loading = false;
				this.$message.error('Non online payment,Please Upload the receipts after you made the payment.');
				return
			}
			const fm = this.familyMembers.filter((item) => {
			    const keys = Object.keys(item);
			    if (keys.every((fm) => !!item[fm]))
			        return true;
			    return false;
			});
			const fms = this.familyMemberss.filter((item) => {
			    const keys = Object.keys(item);
			    if (keys.every((fm) => !!item[fm]))
			        return true;
			    return false;
			});
			this.model['family_member'] = JSON.stringify([].concat(fm, fms));
			const hr = this.replaceHelpers.filter((item) => {
			    const keys = Object.keys(item);
			    if (keys.every((hr) => !!item[hr]))
			        return true;
			    return false;
			});
			this.model['remark_1'] = JSON.stringify([].concat(hr));
			const oh = this.otherHelpers.filter((item) => {
			    const keys = Object.keys(item);
			    if (keys.every((hr) => !!item[hr]))
			        return true;
			    return false;
			});
			this.model['remark_2'] = JSON.stringify([].concat(oh));
			
			let ha = '';
			if (this.helperRoom === 'yes') {
			    ha = this.$t('r12') + this.hr11 + this.$t('r13') + this.hr12;
			} else {
			    ha += this.$t('r16') + '. ';
			    if (this.h2 === '1') {
			        ha += (this.$t('r17') + this.h211 + this.$t('r13') + this.h212 + this.h213 + this.$t('age') + this.h214 + this.$t('r19'));
			    } else if (this.h2 === '2') {
			        ha += (this.$t('r191') + this.h221 + this.$t('r13') + this.h222);
			    } else if (this.h2 === '3') {
			        ha += (this.$t('r20') + this.h231);
			    }
			}
			this.model['helper_accommodation'] = ha;
			this.model['total_money'] = this.totalPrice;
			this.model['last_visa_date'] = this.date1;
			this.model['last_working_date'] = this.date2;
			// if(this.date1){
			// 	this.model['last_visa_date'] = format(this.date1, 'MM/dd/yyyy');
			// }
			// if(this.date2){
			// 	this.model['last_working_date'] = format(this.date2, 'MM/dd/yyyy');
			// }
			const emptyfi = Object.keys(this.model).find((key) => this.model[key] === undefined);
			if (emptyfi) {
			    this.loading = false;
			    this.err = emptyfi + ' is required';
			} else {
			    this.$service.renew(this.model).then((res) => {
			        this.loading = false;
					this.canSubmit = false;
			        this.$message('Submit Success')
			    }).catch((err) => {
			        if (err && (err.status === 400) && err.message != 'Network Error'){
						this.err = err.message;
					}
			        // else this.err = 'Renew Error';
			        this.loading = false;
			    });
			}
		},
        onPayClick() {
			this.err = '';
			this.loading = true;
			this.success = false;
            var id = this.orderNo || this.orderId;
            if (id) {
                const params = {order_number: id};
                const payUrl = this.$service.getPay(params);
				let obj = document.getElementById('payLinks');
				obj.href = payUrl;
				obj.click();
                this.checkOrder(id);
                return;
            }

            const fm = this.familyMembers.filter((item) => {
                const keys = Object.keys(item);
                if (keys.every((fm) => !!item[fm]))
                    return true;
                return false;
            });
            const fms = this.familyMemberss.filter((item) => {
                const keys = Object.keys(item);
                if (keys.every((fm) => !!item[fm]))
                    return true;
                return false;
            });
            this.model['family_member'] = JSON.stringify([].concat(fm, fms));
            const hr = this.replaceHelpers.filter((item) => {
                const keys = Object.keys(item);
                if (keys.every((hr) => !!item[hr]))
                    return true;
                return false;
            });
            this.model['remark_1'] = JSON.stringify([].concat(hr));
            const oh = this.otherHelpers.filter((item) => {
                const keys = Object.keys(item);
                if (keys.every((hr) => !!item[hr]))
                    return true;
                return false;
            });
            this.model['remark_2'] = JSON.stringify([].concat(oh));

            let ha = '';
            if (this.helperRoom === 'yes') {
                ha = this.$t('r12') + this.hr11 + this.$t('r13') + this.hr12;
            } else {
                ha += this.$t('r16') + '. ';
                if (this.h2 === '1') {
                    ha += (this.$t('r17') + this.h211 + this.$t('r13') + this.h212 + this.h213 + this.$t('age') + this.h214 + this.$t('r19'));
                } else if (this.h2 === '2') {
                    ha += (this.$t('r191') + this.h221 + this.$t('r13') + this.h222);
                } else if (this.h2 === '3') {
                    ha += (this.$t('r20') + this.h231);
                }
            }
            this.model['helper_accommodation'] = ha;
            this.model['total_money'] = this.totalPrice;
			this.model['last_visa_date'] = this.date1;
			this.model['last_working_date'] = this.date2;
			// if(this.date1){
			// 	this.model['last_visa_date'] = format(this.date1, 'MM/dd/yyyy');
			// }
			// if(this.date2){
			// 	this.model['last_working_date'] = format(this.date2, 'MM/dd/yyyy');
			// }
            const emptyfi = Object.keys(this.model).find((key) => this.model[key] === undefined);
            if (emptyfi) {
                this.loading = false;
                this.err = emptyfi + ' is required';
            } else {
                this.$service.renew(this.model).then((res) => {
                    const params = {order_number: res.data['order_number']};
                    const payUrl = this.$service.getPay(params);
					let obj = document.getElementById('payLinks');
					obj.href = payUrl;
					obj.click();
                    this.checkOrder(res.data['order_number']);
                }).catch((err) => {
                    if (err && (err.status === 400) && err.message != 'Network Error'){
						this.err = err.message;
					}
                    // else this.err = 'Renew Error';
                    this.loading = false;
                });
            }

        },
        checkOrder(orderNo) {
            const _check = (params) => {
                this.$service.checkPay(params).then((res) => {
                    this.price = res.data.total_money;
                    if (res.data.status) { // 支付成功
                        this.loading = false;
                        this.success = true;
                    } else {
                        setTimeout(() => _check(params), 3000);
                    }
                }).catch((res = {}) => {
					if(res.message !== 'Network Error'){
						this.err = res.message || 'error pay';
					}
                    this.loading = false;
                });
            };
            _check({order_number: orderNo});
        },
        addFM() {
            if (this.canAddfm) {
                this.familyMembers.push(fm());
                this.familyMemberss.push(fm());
            }
        },
        addHR() {
            this.replaceHelpers.push(hr());
        },
        addOH() {
            this.otherHelpers.push(oh());
        },
		getCacheTable(){
			const params = {
				type:this.type,
				category:'renew',
			}
			this.$service.getCacheTable(params).then((res)=>{
				// this.tableData = res.data;
				if(res.status != 200) return;
				var tableData = res.data;
				if(tableData == '') return;
				if(tableData['last_visa_date']){
					this.date1 = new Date(tableData['last_visa_date']);
				}
				if(tableData['last_working_date']){
					this.date2 = new Date(tableData['last_working_date']);
				}
				Object.keys(tableData).forEach(k=>{
					if(typeof(tableData[k]) === 'number'){
						tableData[k] = tableData[k].toString();
					}
					if(
						k == 'family_member' || k == 'remark_1'
						|| k == 'remark_2'
					){
						if(tableData[k] != ''){
							if(typeof(tableData[k]) === 'object'){
								this.model[k] = tableData[k];
							}
							if(typeof(tableData[k]) === 'string'){
								this.model[k] = JSON.parse(tableData[k]);
							}
						}
					}else if(
						k == 'familyMembers' || k == 'familyMemberss' || k == 'replaceHelpers' || k == 'otherHelpers'
					){
							if(typeof(tableData[k]) === 'object'){
								this[k] = tableData[k];
							}
							if(typeof(tableData[k]) === 'string'){
								this[k] = JSON.parse(tableData[k]);
							}
					}else{
						const keysArr = [
							'helperRoom','hr11','hr12','h2','h211','h212','h213','h214','h221','h222','h231'
						];
						var that = this;
						keysArr.forEach(function(v){
							if(k === v){
								that[k] = tableData[k]
							}
						});
						this.model[k] = tableData[k];
					}
				})
			})
		},
		postCacheTable(){
			const params = {
				type:this.type,
				category:'renew',
				table:JSON.stringify(this.model)
			}
			this.$service.postCacheTable(params);
		}
    }
}
</script>
<style module>
.reqP {
	margin-bottom: 0.625rem;
}
.verticalrg {
  display: flex;
  flex-direction: column;
}
.editbtn {
	color: #f3b707e6;
	cursor: pointer;
	text-decoration: underline;
	transition:all .4s;
	-moz-transition:all .4s;
	-webkit-transition:all .4s;
	-o-transition:all .4s;
}
.list {
    list-style: none;
    width: 65%;
    font-size: 24px;
    margin-top: 54px;
    font-weight: 400;
}
.list > li:before {
    content: "\02022";
    color: #eeb40ad1;
    font-size: 40px;
    padding-right: 10px;
    position: relative;
    top: 6px;
}
.list > li {
    margin-top: -5px;
}
.wra {
    width: 45%;
    padding: 90px 0;
}
.fisrt {
    font-size: 34px;
    font-weight: 500;
}
.second {
    margin-top: 40px;
    font-size: 58px;
    font-weight: 500;
}
.right {
    padding-top: 50px;
}
.incost {
    margin-top: 10px;
    margin-left: 37px;
    font-size: 20px;
}
.add {
    cursor: pointer;
}
.add[disabled] {
    cursor: not-allowed;
}
.add[disabled] > img {
    opacity: 0.4;
}
.add[disabled] {
    color: gray;
}
.hi1 {
    width: 45%;
}
.pt100 {
    padding: 100px 0px;
}
.step4 {
    width: 50%;
}
.s4 {
    margin:80px;
}
.s41 {
    width:50px;
}
.credentialDiv {
	background-color: #F5F5F5;
	width: 40.625rem;
	min-height: 12.5rem;
	text-align: center;
	margin: 20px auto;
	padding-top: 10px;
	padding-bottom: 20px;
}
@media screen and (max-width: 770px) {
	.credentialDiv {
		background-color: #F5F5F5;
		width: 20.625rem;
		min-height: 12.5rem;
		text-align: center;
		margin: 20px auto;
		padding-top: 10px;
		padding-bottom: 20px;
	}
    .list {
        list-style: none;
        width: 230%;
        font-size: 12px;
        margin-top: 0px;
        font-weight: 400;
        transform: scale(0.633333);
    }
    .list > li:before {
        content: "\02022";
        color: #eeb40ad1;
        font-size: 14px;
        padding-right: 10px;
        position: relative;
        top: 2px;
    }
    .list > li {
        margin-top: -5px;
    }
    .wra {
        width: 45%;
        padding: 20px 0;
    }
    .fisrt {
        font-size: 12px;
        font-weight: 500;
    }
    .second {
        margin-top: 10px;
        font-size: 18px;
        font-weight: 500;
    }
    .right {
        padding-top: 50px;
    }
    .full {
        width: 100%;
    }
    .hi1 {
        width: 100%;
        margin-right: 0px;
    }
    .pt100 {
        padding: 30px 0px;
    }
    .step4 {
        width: 100%;
    }
    .s4 {
        margin: 20px;
    }
    .s41 {
        width: 37px;
    }
}
</style>
